import { render, staticRenderFns } from "./assessment-summary.vue?vue&type=template&id=17f39de8&scoped=true&lang=pug&"
import script from "./assessment-summary.vue?vue&type=script&lang=ts&"
export * from "./assessment-summary.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-summary.vue?vue&type=style&index=0&id=17f39de8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f39de8",
  null
  
)

export default component.exports